export default __webpack_public_path__ + "static/media/terms-of-service-consent-kr-1.9ee65fde.jpg";